'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
class $c_Lpresto_Fetcher$FetchError extends $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception {
  constructor(message, request, response) {
    super();
    this.JF = null;
    this.JG = null;
    this.Xo = null;
    this.JF = message;
    this.JG = request;
    this.Xo = response;
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
  x() {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
  }
  p() {
    return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
  }
  i(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lpresto_Fetcher$FetchError)) {
      if ((this.JF === x$0.JF)) {
        var x = this.JG;
        var x$2 = x$0.JG;
        var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.Xo, x$0.Xo);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  r() {
    return 3;
  }
  s() {
    return "FetchError";
  }
  j(n) {
    switch (n) {
      case 0: {
        return this.JF;
        break;
      }
      case 1: {
        return this.JG;
        break;
      }
      case 2: {
        return this.Xo;
        break;
      }
      default: {
        throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
      }
    }
  }
}
export { $c_Lpresto_Fetcher$FetchError as $c_Lpresto_Fetcher$FetchError };
function $isArrayOf_Lpresto_Fetcher$FetchError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ig)));
}
export { $isArrayOf_Lpresto_Fetcher$FetchError as $isArrayOf_Lpresto_Fetcher$FetchError };
var $d_Lpresto_Fetcher$FetchError = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$FetchError, "presto.Fetcher$FetchError", ({
  ig: 1,
  L: 1,
  F: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lpresto_Fetcher$FetchError as $d_Lpresto_Fetcher$FetchError };
//# sourceMappingURL=presto.-Fetcher$-Fetch-Error.js.map
